import { toJS, observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api"
const { operate } = api


class LiyeOperateStore {
  // 获取信息列表
  @observable infoList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1
    }
  }

  @action async getInfoList(params) {
    const { data } = await httpClient.get(operate.GET_LIYE_INFO_LIST, { params })
    if(data) {
      this.infoList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page
        }
      }
    }
  }

  // 删除/置顶信息。0取消置顶 1置顶 3删除
  @action async delInfo(params) {
    switch(params.modalType) {
      case 0: httpClient.post(operate.SET_TOP_LIYE_INFO, { itemsId: params.itemsId, istop: params.modalType }); break
      case 1: httpClient.post(operate.SET_TOP_LIYE_INFO, { itemsId: params.itemsId, istop: params.modalType }); break;
      case 3: httpClient.post(operate.DEL_LIYE_INFO, {...params}); break;
    }
  }

  // 设置标签类型
  @action setLabelType(params) {
    return httpClient.post(operate.SET_LABEL_TYPE, {...params})
  }


  // 获取产品类型列表
  @observable productTypeList = []
  @action async getProductTypeList(params) {
    const { data } = await httpClient.get(operate.GET_PRODUCT_TYPE_LIST, { params })
    if(data) {
      this.productTypeList = data
    }
  }

  // 获取小程序二维码
  @observable qaCode = ''
  @action async getQaCode(params) {
    const { data } = await httpClient.get(operate.GET_LIYE_QACODE, { params })
    return data
  }

  


  // 获取信息详情
  @observable infoDetailInfo = {}
  @action async getInfoDetail(params) {
    const { data } = await httpClient.get(operate.GET_LIYE_INFO_DETAIL, { params })
    this.infoDetailInfo = data
  }
  
  // 获取回复列表
  @observable commentList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1
    }
  }

  @action async getCommentList(params) {
    const { data } = await httpClient.get(operate.GET_LIYE_INFO_COMMENT_LIST, { params })
    if(data) {
      this.commentList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page
        }
      }
    }
  }

  // 获取浏览记录列表
  @observable browseList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1
    }
  }

  @action async getBrowseList(params) {
    const { data } = await httpClient.get(operate.GET_LIYE_INFO_BROWSE_LIST, { params })
    if(data) {
      this.browseList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page
        }
      }
    }
  }

  // 重置详情
  @action resetInfoDetail() {
    this.infoDetailInfo = {}
    this.commentList = {
      list: [],
      pages: {
        total: 0,
        pageSize: 20,
        currentPage: 1
      }
    }
    this.browseList = {
      list: [],
      pages: {
        total: 0,
        pageSize: 20,
        currentPage: 1
      }
    }
  }



  // 获取轮播图列表
  @observable bannerList = []
  @action async getBannerList(params) {
    const { data } = await httpClient.get(operate.GET_LIYE_BANNER_LIST, { params })
    if(data) {
      this.bannerList = data
    }
  }

  // 新增banner
  @action async updateBanner(params) {
    return params.isAdd
      ? httpClient.post(operate.ADD_BANNER, {...params})
      : httpClient.post(operate.EDIT_BANNER, {...params})
  }

  // 删除banner
  @action async delBanner(params) {
    return httpClient.post(operate.DEL_BANNER, {...params})
  }


    

  // 获取信息类型列表
  @observable infoTypeList = []
  @action async getInfoTypeList(params) {
    const { data } = await httpClient.get(operate.GET_LIYE_INFO_TYPE_LIST, { params })
    if(data) {
      this.infoTypeList = data
    }
  } 

  // 新增信息类型
  @action async updateInfoType(params) {
    return params.isAdd
      ? httpClient.post(operate.ADD_INFO_TYPE, {...params})
      : httpClient.post(operate.EDIT_INFO_TYPE, {...params})
  }

  // 更改信息类型启用状态&删除
  @action async changeInfoTypeState(params) {
    return await httpClient.post(operate.CHANGE_INFO_TYPE, { ...params });

    // // 更改state.infoList 以更新页面展示
    // const _newList = this.infoTypeList.list
    // _newList.filter(item => item.categoryId === params.categoryId)[0].state = params.state
    // this.infoTypeList.list = toJS(_newList)
  }



  // 获取用户列表
  @observable userList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1
    }
  }
  @action async getUserList(params) {
    const { data } = await httpClient.get(operate.GET_USER_LIST, { params })
    if(data) {
      this.userList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page
        }
      }
    }
  }

  // 更改用户启用状态&删除
  @action async changeUserState(params) {
    return await httpClient.post(operate.CHANGE_USER_TYPE, { ...params });
  }

  // 获取用户数据详情
  @observable userData = {}
  @action async getUserData(params) {
    const { data } = await httpClient.post(operate.GET_USER_DATA, { ...params })
    if(data) {
      this.userData = {
        today: data.filter(item => item.dataType === 'today')[0],
        compare: data.filter(item => item.dataType === 'compare')[0],
        yesterday: data.filter(item => item.dataType === 'yesterday')[0],
      }
      this.infoData = data

    }
  }

  // 获取信息数据详情
  @observable infoData = {}
  @action async getInfoData(params) {
    const { data } = await httpClient.post(operate.GET_INFO_DATA, { ...params })
    if(data) {
      this.infoData = data
    }
  }
  // 获取信息数据详情
  @observable infoRankList = []
  @action async getRankList(params) {
    const { data } = await httpClient.post(operate.GET_INFO_RANK_LIST, { ...params })
    if(data) {
      this.infoRankList = data
    }
  }


}

export default new LiyeOperateStore();
